module.exports = __webpack_public_path__ + "static/media/user.20233e0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user.svg
// module id = 315
// module chunks = 0